import clsx from 'clsx';
import { FieldWrapper } from './FieldWrapper';
import { useCallback } from 'react';

export const InputField = (props) => {
  const {
    type = 'text',
    label,
    className,
    onChange,
    maxLength,
    caption,
    disabled,
    value,
    registration,
    error,
    required,
    textTransform = 'normal',
    startIcon,
    endIcon,
    variant = 'default',
    contentType = 'normal',
    placeholder,
  } = props;

  const variants = {
    default:
      'bg-white/10 dark:bg-white/10 border-transparent dark:border-white/10 backdrop-blur-sm focus:ring-cyan-400 focus:border-cyan-400 text-white placeholder-gray-400',
    outlined:
      'border-2 border-cyan-400 focus:ring-cyan-400 focus:border-cyan-400 text-white placeholder-gray-400',
    filled:
      'bg-white/20 dark:bg-white/10 border-transparent focus:ring-cyan-400 focus:border-cyan-400 text-white placeholder-gray-400',
    danger:
      'border-red-500 text-red-500 placeholder-red-400 focus:ring-red-500 focus:border-red-500',
  };

  const formatFiat = (numStr) => {
    const num = parseFloat(numStr.replace(/,/g, ''));
    if (isNaN(num)) return '';
    return num.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handleInputChange = useCallback(
    (e) => {
      let newValue = e.target.value;

      if (contentType === 'numeric') {
        newValue = newValue.replace(/\D/g, '');
      } else if (contentType === 'fiat') {
        newValue = newValue.replace(/[^0-9.]/g, '');
        const parts = newValue.split('.');
        if (parts.length > 2) return;
        newValue = formatFiat(newValue);
      }

      if (onChange) {
        const syntheticEvent = {
          ...e,
          target: {
            ...e.target,
            value: newValue,
          },
        };
        onChange(syntheticEvent);
      }
    },
    [contentType, onChange]
  );

  return (
    <FieldWrapper label={label} error={error}>
      <div
        className={clsx(
          'relative flex items-center rounded-2xl shadow-inner backdrop-blur-md',
          { 'opacity-70 cursor-not-allowed': disabled },
          className
        )}
      >
        {startIcon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-white/70">
            {startIcon}
          </div>
        )}
        <input
          type={type}
          maxLength={maxLength}
          value={value}
          disabled={disabled}
          required={required}
          placeholder={placeholder}
          className={clsx(
            `block w-full py-3 h-[50px] px-3 rounded-2xl focus:outline-none placeholder:text-white/40 focus:ring-0 sm:text-sm`,
            variants[variant],
            { 'pl-10': startIcon, 'pr-10': endIcon },
            {
              uppercase: textTransform === 'uppercase',
              lowercase: textTransform === 'lowercase',
            },
            className
          )}
          onChange={handleInputChange}
          style={{ textTransform }}
          {...registration}
        />
        {endIcon && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-auto text-white">
            {endIcon}
          </div>
        )}
      </div>
      {caption && (
        <div className="my-1 text-xs text-gray-400 flex justify-end">
          {caption}
        </div>
      )}
    </FieldWrapper>
  );
};